<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" class="searchForm" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <!--计划单据编号-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.MSVNumber')" prop="msvNo">
                  <el-input v-model.trim="queryCondition.msvNo" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <!--拜访年份-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Year')" prop="Year">
                  <el-date-picker v-model="queryCondition.year" type="year" clearable value-format="yyyy" placeholder="选择年" style="width:100%">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!--供应商类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Type')" prop="type">
                  <el-select v-model="queryCondition.type" clearable @change="typeChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in typeList" :label="item.chineseValue" :value="item.code"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!--类型-->
              <el-col :span="6">
                <el-form-item :label="$t('visitPlan.Category')" prop="category">
                  <el-select v-model="queryCondition.category" clearable @change="CategoryChange" style="width:100%">
                    <el-option :key="index" v-for="(item,index) in categoryList" :label="item.NAME" :value="item.NAME"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <!--供应商工厂-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.SupplierFacility')" prop="tmSupplierId">
                    <el-input v-model="queryCondition.supplierName" clearable @clear="clearSupplierName" style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchSupplier()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--报告状态-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.ReportStatus')" prop="status">
                    <el-select v-model="queryCondition.status" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in MSVStatusList" :label="item.chineseValue" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <!--拜访日期-->
                <!-- <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.VisitDate')" prop="dataArr">
                    <el-date-picker ref="dataArrRef" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="拜访日期(从)" prop="visitBeginDate">
                    <el-date-picker style="width: 100%" v-model="queryCondition.visitBeginDate" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访日期(至)" prop="visitEndDate">
                    <el-date-picker style="width: 100%" v-model="queryCondition.visitEndDate" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <!--创建人-->
                <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.CreateUser')">
                    <el-input v-model.trim="queryCondition.creater" clearable style="width:100%">
                      <el-button slot="append" icon="el-icon-search" @click="searchCreateBy()"></el-button>
                    </el-input>
                  </el-form-item>
                </el-col>
                <!--创建时间-->
                <!-- <el-col :span="6">
                  <el-form-item :label="$t('visitPlan.CreateDate')" prop="dataArr2">
                    <el-date-picker ref="dataArr2Ref" v-model="queryCondition.dataArr2" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col> -->
                <el-col :span="6">
                  <el-form-item label="创建时间(从)" prop="createQueryBeginData">
                    <el-date-picker style="width: 100%" v-model="queryCondition.createQueryBeginData" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="创建时间(至)" prop="createQueryEndData">
                    <el-date-picker style="width: 100%" v-model="queryCondition.createQueryEndData" type="date" :picker-options="pickerOptionsStart" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
                    <!-- <el-date-picker ref="rateDatePk" v-model="queryCondition.dataArr" type="daterange" :range-separator="$t('common.to')" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')" clearable style="width:100%"></el-date-picker> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryFormThis" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportAdd" @click="addVisitReport">新增拜访报告</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportInactive" @click="inactive">Inactive</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportExport" @click="reportExport">{{$t('base.linePrice.export')}}</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportDownloadZip" @click="CQSDownload">CQS附件下载</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportSPDownloadZip" @click="SPDownload">SP附件下载</el-button>
      <el-button size="mini" class="btn" type="primary" v-acl="Msv-reportTerminate" @click="discontinueClick">中止</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" row-key="ttMsvReportId" border max-height='450' highlight-current-row>
      <el-table-column type="selection" fixed min-width="50" :reserve-selection="true"></el-table-column>
      <el-table-column type="index" min-width="50" :label="$t('visitPlan.SerialNumber')" fixed></el-table-column>
      <el-table-column show-overflow-tooltip prop="msvNo" label="MSV 单据编号" fixed min-width='130'>
        <template slot-scope="scope">
          <div class="a-link" @click="toReportDetail(scope.row.ttMsvReportId,scope.row)">{{scope.row.msvNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="visitPlanMsvNo" label="计划编号" fixed min-width='90'>
        <template slot-scope="scope">
          <div class="a-link" @click="toPlantDetail(scope.row.ttMsvId)">{{scope.row.visitPlanMsvNo}}</div>
        </template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="year" :label="$t('visitPlan.Year')" min-width='70'></el-table-column>
      <el-table-column show-overflow-tooltip prop="type" :label="$t('visitPlan.Type')" min-width='80'></el-table-column>
      <el-table-column show-overflow-tooltip prop="category" :label="$t('visitPlan.Category')" min-width='80'></el-table-column>
      <el-table-column show-overflow-tooltip prop="plantName" label="工厂" min-width='210'></el-table-column>
      <el-table-column show-overflow-tooltip prop="statusI18n" :label="$t('visitPlan.ReportStatus')" min-width='90'></el-table-column>
      <el-table-column show-overflow-tooltip prop="visitBeginDate" :label="$t('visitPlan.VisitDate')" min-width='170'>
        <template slot-scope="scope">{{scope.row.visitBeginDate | dateFormatFilter("YYYY-MM-DD")}}——{{scope.row.visitEndDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
      <el-table-column show-overflow-tooltip prop="mgtRecap" :label="$t('visitPlan.mgtRecap')" min-width='130'></el-table-column>
      <el-table-column show-overflow-tooltip prop="msvResultI18n" label="拜访反馈结果" min-width='120'></el-table-column>
      <el-table-column show-overflow-tooltip prop="creater" min-width='120' :label="$t('visitPlan.CreateUser')"></el-table-column>
      <el-table-column show-overflow-tooltip prop="createDate" :label="$t('visitPlan.CreateDate')" min-width='100'>
        <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD")}}</template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog :visible.sync="showSelSupplierDialog" append-to-body width="80%">
      <SelSupplier :multipleSelectionFlag="true" :supplier-info-only="isHGS" v-if="DestroyIncomeStatistics == true" ref="supplierSelRef" :categoryLevel1Name=categoryLevel1Name :categoryLevel2Name=categoryLevel2Name @subCallMethod="selectSupplierMethod"></SelSupplier>
    </el-dialog>
    <el-dialog :visible.sync="showUserDialog" width="80%">
      <PickupUser @input="selectUserData"></PickupUser>
    </el-dialog>
    <el-dialog title="原因" :visible.sync="ReasonVisible" width="40%">
      <el-form :model="ReasonForm" ref="ReasonForm" :rules="ReasonFormRules" inline>
        <el-form-item label="请填写原因 " label-width="120" prop="comments" class="comments">
          <el-input v-model="ReasonForm.comments" maxlength="300"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="ReasonVisible = false" type="primary">取消</el-button>
        <el-button size="mini" type="primary" @click="defineInactive('ReasonForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="中止拜访报告" :visible.sync="breakDialogVisible" width="40%">
      <el-form :model="breakForm" ref="breakForm" :rules="breakFormRules" label-position="right">
        <el-form-item label="中止原因" label-width="auto" prop="comments" class="comments">
          <el-input v-model="breakForm.comments" maxlength="300" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" style="width:100%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="onConfirm()">确定</el-button>
        <el-button size="mini" @click="onCancel" type="primary">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getVisitReportList, visitReportInactive, exportVisitReportPlan, downLoadZipCQS, downLoadZipSP, getCategoryValue, terminateMsvResport } from "@/api/visitPlan.js";
import PickupUser from "@/components/page/visitPlan/choiceUser";
import { applyService } from "../../../api/quotation-apply/quotation-apply";
import { inputChoiceService } from "../../../api/common/input-choice";
import commonFunction from "../../../utils/dataTableUtils";
import SelSupplier from "@/components/page/visitPlan/supplierFactory";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";
import store from '@/store/index';
import paginationMixin from '@/mixins/pagitionMixin';
export default {
  name: "",
  mixins: [paginationMixin],
  components: { PickupUser, SelSupplier },
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      ReasonVisible: false,
      breakDialogVisible: false,
      ReasonForm: {
        comments: ""
      },
      ReasonFormRules: {
        comments: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      },
      breakForm: {
        comments: ""
      },
      breakFormRules: {
        comments: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur"
          }
        ]
      },
      totalCount: 0,
      tableList: [],
      typeList: [],
      categoryList: [],
      MSVStatusList: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        creater: '',
        year: '',
        supplierCode: '',
        supplierName: '',
        category: '',
        msvNo: '',
        status: '',
        type: '',
        visitBeginDate: "",
        visitEndDate: "",
        createQueryBeginData: "",
        createQueryEndData: "",
        // dataArr: [],
        // dataArr2: []
      },
      statusList: [],
      quotationStatusList: [],
      quotationTypeList: [],
      applyTypeList: [],
      radioVal: null,
      selectRow: null,
      showUserDialog: false,
      showSelSupplierDialog: false,
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      DestroyIncomeStatistics: false,
      username: '',
      SuperAdmin: false,
      categoryLevel1Name: '',
      categoryLevel2Name: '',
      isHGS: false,
      ttMsvReportIds: []
    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    console.log('from', from);
    next(vm => {
      vm.queryCondition = to.meta.reqData;
      // if (to.query.facilityCode) {
      //   vm.queryCondition.supplierCode = to.query.facilityCode
      // }
      if (to.query.ttQspiFacilityFactorScoreId) {
        vm.queryCondition.ttQspiFacilityFactorScoreId = to.query.ttQspiFacilityFactorScoreId
      }
      vm.username = localStorage.getItem("ms_username");
      let permission = JSON.parse(localStorage.getItem("ms_Permission"));
      for (let i = 0, len = permission.length; i < len; i++) {
        if (permission[i] == 'MSV_ADMIN') {//超级管理员
          vm.SuperAdmin = true;
        }
      }
      if (commonFun.havePermission('IS_HGS')) {
        vm.isHGS = true;
      }
      vm.queryData(1);
    })
  },
  created() {
    /*    this.username = localStorage.getItem("ms_username");
        let permission = JSON.parse(localStorage.getItem("ms_Permission"));
        for (let i = 0,len=permission.length;i<len;i++){
            if(permission[i]=='MSV_ADMIN'){//超级管理员
              this.SuperAdmin = true;
            }
        }
          if (commonFun.havePermission('IS_HGS')) {
              this.isHGS = true;
          }
        this.queryData(1);*/
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      let that = this
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      // let dataValue = that.queryCondition.dataArr;
      // let dataArr2Value = that.queryCondition.dataArr2;
      // this.queryCondition.visitBeginDate = !!dataValue ? this.$options.filters["dateFormatFilter"](dataValue[0]) : "",
      //   this.queryCondition.visitEndDate = !!dataValue ? this.$options.filters["dateFormatFilter"](dataValue[1]) : "",
      //   this.queryCondition.createQueryBeginData = !!dataArr2Value ? this.$options.filters["dateFormatFilter"](dataArr2Value[0]) : "",
      //   this.queryCondition.createQueryEndData = !!dataArr2Value ? this.$options.filters["dateFormatFilter"](dataArr2Value[1]) : ""
      getVisitReportList(this.queryCondition).then(res => {
        that.pageshow = true
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
      });
    },
    discontinueClick() {
      let rows = this.$refs.tableList.selection;
      if (rows.length == 0) {
        this.$message({ message: "请至少选择一条数据", type: "warning" });
        return false
      }
      // var flag = rows.some(ele => {
      //   return ele.status == 'FINAL' || ele.status == 'CQS_DRAFT' || ele.status == 'SP_DRAFT'
      // })
      // if (flag) {
      //   this.$message({ message: "您勾选的数据状态为草稿或者已报告完结，无法中止！", type: "warning" });
      //   return false
      // }
      this.ttMsvReportIds = []
      this.ttMsvReportIds = rows.map(ele => ele.ttMsvReportId)
      this.breakDialogVisible = true
    },
    onConfirm() {
      console.log("GY🚀 ~ this.$refs['breakForm'].validate ~ this.ttMsvReportIds:", this.ttMsvReportIds);
      this.$refs['breakForm'].validate((valid) => {
        if (valid) {
          terminateMsvResport({
            remarks: this.breakForm.comments,
            ttMsvReportIds: this.ttMsvReportIds
          }).then(res => {
            console.log("GY🚀 ~ this.$refs['breakForm'].validate ~ res:", res);
            if (res.meta.code == 200) {
              this.$message({ message: "中止成功", type: "success" });
              this.onCancel()
            }
          })
        }
      })
    },
    onCancel() {
      this.breakDialogVisible = false
      this.breakForm.comments = ''
      this.ttMsvReportIds = []
      this.$refs.tableList.clearSelection();
      this.queryData(1)
    },
    inactive() {
      let that = this;
      let list = that.tableList
      let rows = this.$refs.tableList.selection;
      console.log(rows.length)
      if (rows.length == 0) {
        that.$message({ message: "请选择需要Inactive的数据", type: "warning" });
      } else {
        for (let i = 0, len = rows.length; i < len; i++) {
          if (!that.SuperAdmin) {
            if (rows[i].creater != that.username) {
              that.$message({ message: "只能对自己创建的数据进行操作", type: "warning" });
              return false;
            }
          }
          if (rows[i].status == 'CANCLE') {
            that.$message({ message: "存在已Inactive的报告，不能重复Inactive，请重新选择", type: "warning" });
            return false;
          }
          if (rows[i].status == 'COMPLETED' || rows[i].status == 'SP_DRAFT' || rows[i].status == 'SP_SUBMIT' || rows[i].status == 'FINAL') {
            that.$message({ message: "已下发的报告不能Inactive，请重新选择", type: "warning" });
            return false;
          }
        }
        that.ReasonVisible = true
      }
    },
    defineInactive(formName) {
      let that = this;
      let rows = that.$refs.tableList.selection;
      this.$refs[formName].validate(valid => {
        if (valid) {
          that.refuseVisible = false;
          var ttMsvReportIds = rows.map(function (item) {
            let obj = item["ttMsvReportId"];
            return obj;
          });
          var data = {
            "remarks": that.ReasonForm.comments,
            "ttMsvReportIds": ttMsvReportIds
          }
          console.log(data);
          visitReportInactive(data).then(res => {
            that.ReasonVisible = false
            that.ReasonForm.comments = ''
            if (res.meta.success) {
              that.$message({ type: 'success', message: that.$t('common.success') });
              that.queryData()
            }
          });

        } else {
          return false;
        }
      });
    },
    reportExport() {
      exportVisitReportPlan(this.queryCondition).then(res => {
        if (window.navigator.msSaveBlob) {
          try {
            let data = new Blob([res])
            window.navigator.msSaveBlob(data, this.$t("visitPlan.VisitReport") + '.xls');
          } catch (e) {
            this.$message({ type: 'error', message: '文件下载失败' });
          }
        } else {
          try {
            const link = document.createElement("a");
            let blob = new Blob([res], { type: res.type });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob); //创建下载的链接
            link.setAttribute("download", this.$t("visitPlan.VisitReport") + '.xls'); //下载后文件名
            document.body.appendChild(link);
            link.click(); //模拟在按钮上的一次鼠标单击
            document.body.removeChild(link); //释放URL 对象
          } catch (e) {
            this.$message({
              type: "error",
              message: this.$t("base.linePrice.fileDownloadError")
            });
          }
        }

      });
    },
    formaVisitPlanStatus: function (row, column) {
      return row.visitPlanStatus == "DRAFT" ? "草稿" : row.visitPlanStatus == "SUBMIT" ? "提交" : "";
    },
    formatStatus: function (row, column) {
      console.log(row.status)
      // 共6个状态CQS_DRAFT，CQS_SUBMIT，COMPLETED，REJECT，SP_DRAFT，SP_SUBMIT
      return row.status == 'CQS_DRAFT'
        ? "CQS草稿"
        : row.status == 'CQS_SUBMIT'
          ? "CQS提交"
          : row.status == 'COMPLETED'
            ? "完成"
            : row.status == 'REJECT'
              ? "拒绝"
              : row.status == 'SP_DRAFT'
                ? "SP草稿"
                : row.status == 'SP_SUBMIT'
                  ? "SP提交"
                  : " ";
    },
    CQSDownload() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      let names = []
      let recIds = []
      if (rows.length == 0) {
        that.$message({ message: "请选择需要下载的数据", type: "warning" });
      } else {
        for (let i = 0, len = rows.length; i < len; i++) {
          names.push(rows[i].msvNo)
          recIds.push(rows[i].ttMsvReportId)
        }
        let data = {
          "names": names,
          "recIds": recIds,
          "tsReckindId": "MSV_REPOR_CQS"
        }
        downLoadZipCQS(data).then((res) => {
          if (window.navigator.msSaveBlob) {
            try {
              let data = new Blob([res])
              window.navigator.msSaveBlob(data, 'CQS附件.zip');
            } catch (e) {
              this.$message({ type: 'error', message: '文件下载失败' });
            }
          } else {
            try {
              const link = document.createElement('a');
              let blob = new Blob([res], { type: res.type });
              link.style.display = 'none';
              link.href = URL.createObjectURL(blob); //创建下载的链接
              link.setAttribute('download', "CQS附件.zip");//下载后文件名
              document.body.appendChild(link);
              link.click();//模拟在按钮上的一次鼠标单击
              document.body.removeChild(link) //释放URL 对象
            } catch (e) {
              this.$message({ type: 'error', message: '文件下载失败' });
            }
          }

        })
      }
    },
    SPDownload() {
      let that = this;
      let rows = this.$refs.tableList.selection;
      let names = []
      let recIds = []
      if (rows.length == 0) {
        that.$message({ message: "请选择需要下载的数据", type: "warning" });
      } else {
        for (let i = 0, len = rows.length; i < len; i++) {
          names.push(rows[i].msvNo)
          recIds.push(rows[i].ttMsvReportId)
        }
        let data = {
          "names": names,
          "recIds": recIds,
          "tsReckindId": "spVisitReport"
        }
        downLoadZipSP(data).then((res) => {
          if (window.navigator.msSaveBlob) {
            try {
              let data = new Blob([res])
              window.navigator.msSaveBlob(data, "SP附件.zip");
            } catch (e) {
              this.$message({ type: 'error', message: '文件下载失败' });
            }
          } else {
            try {
              const link = document.createElement('a');
              let blob = new Blob([res], { type: res.type });
              link.style.display = 'none';
              link.href = URL.createObjectURL(blob); //创建下载的链接
              link.setAttribute('download', "SP附件.zip");//下载后文件名
              document.body.appendChild(link);
              link.click();//模拟在按钮上的一次鼠标单击
              document.body.removeChild(link) //释放URL 对象
            } catch (e) {
              this.$message({ type: 'error', message: '文件下载失败' });
            }
          }

        })
      }
    },
    typeChange(val) {
      this.categoryLevel1Name = val
      this.categoryLevel2Name = ''
      this.queryCondition.supplierCode = ''
      this.queryCondition.supplierName = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      if (val == 'Food') {
        this.getCategory(val)
      } else {
        this.categoryList = []
        this.queryCondition.category = ''
      }
    },
    CategoryChange(val) {
      this.categoryLevel2Name = val
      this.queryCondition.supplierCode = ''
      this.queryCondition.supplierName = ''
      this.queryCondition.tmSupplierIds = []
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
    },
    //动态获取Category下拉框的值
    getCategory(value) {
      let that = this;
      let data = {
        categoryLevel1Name: value
      }
      getCategoryValue(data).then(res => {
        this.categoryList = res.data
      });
    },
    searchSupplier() {
      this.$nextTick(() => {
        this.DestroyIncomeStatistics = true;
      });
      this.showSelSupplierDialog = true
    },
    toPlantDetail(id) {
      if (this.actionCheck.actionCheck('MsvQueryDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }
      this.$router.push({
        path: `/visitPlan-add`,
        query: { ttMsvId: id }
      });
    },
    toReportDetail(id, row) {
      if (this.actionCheck.actionCheck('Msv-reportQueryDetail') === false) {
        this.$message.error(this.$t('common.noPermission'))
        return false
      }

      let resolve = this.$router.resolve({
        path: `/visitReport-add`,
        query: { ttMsvReportId: id, VisitPlanIN: true }
      });
      if (row.visitPlanMsvNo != null) {
        resolve = this.$router.resolve({
          path: `/visitReport-add`,
          query: { ttMsvReportId: id, VisitPlanIN: true }
        });
      } else {
        resolve = this.$router.resolve({
          path: `/visitReport-add`,
          query: { ttMsvReportId: id }
        });
      }
      window.open(resolve.href, "_blank");

    },
    searchCreateBy(value) {
      if (!value) {
        this.showUserDialog = true
      }
    },
    selectUserData(name, id) {
      this.queryCondition.creater = name
      // this.queryCondition.createByName = name
      // this.queryCondition.createBy = id
      this.showUserDialog = false
    },

    selectSupplierMethod: function (supList) {
      let that = this
      that.queryCondition.tmSupplierIds = [];
      that.queryCondition.supplierCode = '';
      that.queryCondition.supplierName = '';
      supList.forEach((item) => {
        that.queryCondition.tmSupplierIds.push(item.tmSupplierId);
        that.queryCondition.supplierCode = that.queryCondition.supplierCode + item.supplierCode + ',';
        that.queryCondition.supplierName = that.queryCondition.supplierName + item.supplierName + ',';
      });
      that.queryCondition.supplierCode = supList.map(sup => sup.supplierCode).join(',');
      that.queryCondition.supplierName = supList.map(sup => sup.supplierName).join(',');
      that.showSelSupplierDialog = false;
    },
    //查询条件重置方法
    restQueryFormThis: function () {
      this.$refs.tableList.clearSelection();
      this.$refs.queryCondition.resetFields();
      this.queryCondition.tmSupplierIds = [];
      this.categoryLevel1Name = '';
      this.categoryLevel2Name = '';
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        creater: '',
        year: '',
        supplierCode: '',
        supplierName: '',
        category: '',
        msvNo: '',
        status: '',
        type: '',
        visitBeginDate: "",
        visitEndDate: "",
        createQueryBeginData: "",
        createQueryEndData: "",
      }
      this.DestroyIncomeStatistics = false;//为了重新渲染子组件
      this.queryData()
    },
    clearSupplierName() {
      this.queryCondition.supplierCode = "";
      this.queryCondition.tmSupplierIds = []
    },
    addVisitReport() {
      this.$router.push({
        path: `/visitReport-add`,
        // query: { applyId: id }
      });
    },
    addNewApply: function (applyId) {
      this.$router.replace({
        name: "applyDetail",
        params: { applyId: applyId, source: "apply" }
      });
    },
    openQuotationApplyDetail: function (row) {
      this.$router.replace({
        name: "applyDetail",
        params: {
          applyId: row.ttQuotationApplyId,
          source: "apply",
          applyType: row.applyType
        }
      });
    },
    selectData(name, id) {
      this.queryCondition.createByName = name
      this.queryCondition.createBy = id
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = [];
      this.selectRow = row;
    },
    getInputChoiceValues() {
      let that = this
      let mapObj = {};
      mapObj["TT_MSV:TYPE"] = "TT_MSV:TYPE";
      mapObj["TT_MSV:REPORTSTATUS"] = "TT_MSV:REPORTSTATUS";
      mapObj["TT_MSV:CATEGORYTYPE"] = "TT_MSV:CATEGORYTYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        let typeList = res["TT_MSV:TYPE"];
        if (that.isHGS) {
          for (let i = 0, len = typeList.length; i < len; i++) {
            if (typeList[i].chineseValue == "Package") {
              that.typeList = [typeList[i]]
            }
          }
        } else {
          that.typeList = typeList
        }
        this.MSVStatusList = res["TT_MSV:REPORTSTATUS"];
        // this.categoryList = res["TT_MSV:CATEGORYTYPE"];
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.categoryList;
      restaurants = restaurants.map(obj => {
        return {
          ...obj,
          value: obj.chineseValue
        }
      })
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    openSoucingInfo: function (sourcingNo) {
      this.$router.push({
        path: "/sourcing-detail",
        query: { sourcingNo: sourcingNo }
      });
    }
  },
  extends: commonFunction
};
</script>
<style lang="scss">
.visitReport {
  .el-form-item__content {
    width: 220px;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor {
    width: 220px !important;
  }
  .comments {
    width: 100%;
    .el-form-item__content {
      width: 80%;
    }
  }
}
</style>
